module.exports = __webpack_public_path__ + "img/insta360.72675243.jpg";